import {PlanKey} from '@/api/organizations/types';
import {PlanType} from '@/pages/UpgradePlan/components/UpgradePlan/types';

export const planKeyMapping: Record<PlanType, PlanKey> = {
    [PlanType.paygo]: PlanKey.PAYGOv2,
    [PlanType.grow]: PlanKey.GROWv2,
    [PlanType.scale]: PlanKey.SCALEv2,
    [PlanType.enterprise]: PlanKey.ENTERPRISEv2
};
